import apiClient from "../apiClient";

const resource = "Employee";

export default {
    getEmployee: () => apiClient.get(`${resource}/Employee`),

};
